export default __webpack_public_path__ + "locales/hy-AM/UploadPanel.json?hash=aecb2d6faf3179e47c270d5085330efc";